import ListOfAlerts from "./ListOfAlerts";

export default ListOfAlerts;